import AutoclickBehaviorAbstract from "../AutoclickBehaviorAbstract";

class AutoclickBehaviorViewableDelay extends AutoclickBehaviorAbstract {
  onViewable() {
    this.delayClickthrough(this.getBehaviorDelay());
  }
}

export default AutoclickBehaviorViewableDelay;



// WEBPACK FOOTER //
// ./src/js/madlib/autoclick/behaviors/AutoclickBehaviorViewableDelay.js